export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "EMAIL_ALREADY_EXISTS_IN_CLASS",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    EMAIL_ALREADY_EXISTS_IN_CLASS: 1,
};
